import angular from 'angular';

import '../../../app.constants';
import '../../../services/notifications';
import '../../../services/organization';
import '../../../services/place';
import '../../../services/appointment';
import '../../../services/errors'


const module = angular.module('whyline.controllers.reception.externalFilter', [
  'whyline.services.place',
  'whyline.services.organization',
  'whyline.constants',
  'whyline.services.notifications',
  'whyline.services.errors',
]);

const AppointmentSearchController = function (SAFE_STATES, $translate, $scope, $state, NotificationService, AppointmentService, OrganizationService, PlaceService) {
  /*@ngInject*/

  $scope.loading = true;
  $scope.appointmentNotFound = false;

  // INIT  
  this.$onInit = function () {
    const appointmentId = $state.params.appointmentId;
    if (!appointmentId) {
      $scope.loading = false;
      appointmentNotFound();
    }
    AppointmentService.getPlaceIdAndOrganizationIdFromAppointment(appointmentId)
      .then(async response => {
        $scope.loading = false;

        const { organizationId = '', placeId = '' } = response.data;

        const params = {
          id: appointmentId,
          type: 'appointment',
          organizationId,
          placeId
        }

        return $state.go(SAFE_STATES.scheduleAppointmentConfirm, params);
      })
      .catch(err => {
        $scope.loading = false;

        if (err.data === 'invalid-appointmentId' || err.data === 'appointment-not-found' || err.data === 'place-not-found') {
          appointmentNotFound()
        } else if (err.data === 'not-authorized') {
          NotificationService.Error($translate.instant('do_not_have_permission_for_this_section'));
          return $state.go(SAFE_STATES.organizationsList, {});
        } else {
          ErrorService.handler(err);
        }
      })
  }

  function appointmentNotFound() {
    NotificationService.Error($translate.instant('result_not_found'));
    return $state.go(SAFE_STATES.organizationsList, {});
  }
};

module.exports = module.controller('ReceptionAppointmentSearchByexternalFilterController', AppointmentSearchController);
